export const TransferIssueTemplate = {
    name: 'transfer_issue',
    label: 'Transfer issue',
    subject: "REBIT ${reference}: Transfer issue!",
    category: 'compulsory',
    body: "<p style='padding:10px;background-color: #fffae6'>⚠️ <b>There was an issue with your Recipient’s details</b></p>"
        + "<p>One of the following data is not valid or doesn’t match:</p>"
        + "<ul>"
        + "<li>IBAN code</li>"
        + "<li>Account number</li>"
        + "<li>Card number</li>"
        + "<li>Account holder's name of the Recipient</li>"
        +"</ul>"
        + "<p><b>What next?</b></p>"
        + "<ol>"
        + "<li><a href='https://my.rebitmoney.com/transfers/history?q=${reference}'>Click here to find order ${reference} in your Transfers History</a>.</li>"
        + "<li>Click on <b>Edit Recipient</b> and follow the steps to update your Recipient’s details.</li>"
        +"</ol>"
}
